import { useState, useEffect } from 'react';

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import { searchRetiredAddress } from '../../../services/APIClient';
import MoveAlternateAddressDialog from './MoveAlternateAddressDialog';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  buttonSubmit: {
    // marginBottom: 10,
    margin: theme.spacing(1),
    height: "85%"
  },
}));

const ManageRetiredAddresses = props => {
  const classes = useStyles();

  const [address, setAddress] = useState("");
  const [retiredAddress, setRetiredAddress] = useState("");
  const [addressData, setAddressData] = useState([]);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(5);
  // const [alternateAddress, setAlternateAddress] = useState("");

  const addressHeader = [
    { field: 'address', headerName: 'Address', width: 300 },
    { field: 'startDate', headerName: 'Start Date', width: 300 },
    { field: 'endDate', headerName: 'End Date', width: 300 },
    {
      field: 'setRetired', headerName: 'Set to Alternate', width: 300, disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = () => {
          console.log(params);
          setRetiredAddress(params.row.address)
          setOpen(true);
        };
        return <Button size="small" color="primary" onClick={onClick}>Submit</Button>;
      }
    },
  ];

  useEffect(() => {
    console.log(retiredAddress);
  }, [retiredAddress])

  const search = () => {
    const params = {
      searchTerm: address
    }
    searchRetiredAddress(params)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data && response.data.length > 0) {
            const formattedData = response.data.map((record, index) => {
              const row = {
                id: index,
                address: record.address,
                startDate: record?.startDate ? record.startDate.slice(0, 10) : null,
                endDate: record?.endDate ? record.endDate.slice(0, 10) : null,
              }
              return row
            })
            setAddressData(formattedData);
          }
        } else {
          setAddressData([]);
          console.log(response);
        }
      })
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.paper}>
      {/* <form autoComplete="off" noValidate onSubmit={mapHandleSubmit}> */}
      <Grid container spacing={1}>
        {/* <Grid item xs={2}>
            <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth disabled={address ? false : true}>Check</Button>
          </Grid> */}
        <Grid item xs={10}>
          <TextField name="address" variant="outlined" label="Address" fullWidth value={address} onChange={(e) => setAddress(e.target.value)} />
        </Grid>
        <Grid item xs={2}>
          <Button
            className={classes.buttonSubmit}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            disabled={address ? false : true}
            onClick={search}
          >
            Search
          </Button>
        </Grid>
        {addressData.length > 0 &&
          <Grid item xs={12}>
            <DataGrid
              columns={addressHeader}
              rows={addressData}
              pageSize={page}
              onPageSizeChange={(pageSize, details) => { setPage(pageSize); }}
              autoHeight
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Grid>
        }
        <Grid item xs={12}>
          <MoveAlternateAddressDialog address={retiredAddress} open={open} handleClose={handleClose} />
        </Grid>
      </Grid>
      {/* </form> */}
    </div>
  )
};

export default ManageRetiredAddresses;